import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  toastId: "",
};

export const utilityDataSlice = createSlice({
  name: "utilityData",
  initialState,
  reducers: {
    openProgressModal: (state) => {
      state.isLoading = true;
    },
    closeProgressModal: (state) => {
      state.isLoading = false;
    },
    setDisplayToast: (state, action) => {
      state.toastId = action.payload;
    },
    resetDisplayToast: (state) => {
      state.toastId = "";
    },
  },
});

export const {
  updateIsMobile,
  openProgressModal,
  closeProgressModal,
  setDisplayToast,
  resetDisplayToast,
} = utilityDataSlice.actions;

export default utilityDataSlice.reducer;
